import script from "./ArchivosPaciente.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchivosPaciente.vue?vue&type=script&setup=true&lang=js"

import "./ArchivosPaciente.vue?vue&type=style&index=0&id=099a9496&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-099a9496"]])

export default __exports__